---
en:
  fall_lease:
    accumulated: Accumulated
    actions: Actions
    active: Active
    approve: Approve
    approve_prompt: You are now overwriting existing calculation. Are you sure to Approve?
    approved: Approved
    averaging_interval: Averaging Interval
    back: Back
    calculation_interval: Calculation Interval
    code_list: Code List
    computable: Computable
    computable_computing: Computation is in progress
    computable_false: Computation failed. Please check if all parameters are correct, or contact Kaia.
    computable_true: Computation is working normally
    computable_unknown: Not computed
    computation_state: Computation State
    compute: Compute
    compute_all_prompt: |-
      You are about to compute All Fall Leases.
      It will take 1-5 minutes for task to complete.
      Are you sure?
    compute_current_year: Compute Current Year
    computing_job_status:
      in_queue: Queued
      not_found: Not found, click to retry
      running: Running
    computing_status: Computation Status
    confirm_code_list_clear: You are going to clear the account code list. Please confirm.
    contract_details: Contract Details
    contract_id: Contract ID
    contract_nr: Contract \#
    contract_structure: Contract Structure
    contract_type: Contract Type
    counterpart: Counterpart
    counterpart_fields:
      add: Add Counterpart
      fall_lease: Estimated fall lease so far this year
      informational_text_accuracy: Inaccuracies and errors will occur both for the current and historical years.
      informational_text_test: This is a test version.
      landowner: Landowner
      landowner_error: Landowner must be selected
      share: Share[%]
      share_error: Total share must not exceed 100%
      show_landowner_info: Fall lease landowner info
    currency: Currency
    disapprove: Disapprove
    download_xlsx: Download (xlsx)
    elcert: Elcert
    elcert_codes: Elcert Code List
    elcert_owners: Elcert Owners
    elcert_share: Elcert Lease Rate
    end_date: End Date
    fall_lease: Fall Lease
    fall_lease_contract_details: Fall lease contract details
    fall_lease_contracts: Fall Lease Contracts
    fall_lease_summary: Fall lease summary
    filter_data: Filter Data
    fixed_price: Land Lease Fee
    goos: GoOs
    goos_codes: GoOs Code List
    goos_owners: GoOs Owners
    goos_share: GoOs Lease Rate
    gross: Gross
    kpi_adjustment: KPI Adjustment
    kpi_end_date_type: KPI End Date
    kpi_ref_date: KPI Ref Date
    loading_please_wait: Loading... Please wait
    lock: Lock
    lock_all: Lock All Years
    lock_prompt: You are now locking parameters. Are you sure to Lock?
    lock_prompt_false: You are now unlocking parameters. Are you sure you want to unlock?
    lock_prompt_true: You are now locking parameters. Are you sure you want to lock?
    locked: Locked
    min_price: Minimum Fall Lease Level
    model_rate: Model Rate - Power Sales Revenues
    model_rate_hint: 'For example: 5'
    model_type: Model Type
    net: Gross with costs
    none: None
    payment_dates: Payment Dates
    payment_interval: Payment Interval
    power_plant_name: Power plant name
    pp_revenues_costs: Power Plant Revenues & Costs
    rate_structure: Lease Structure
    remove_all: Remove All Years
    remove_all_prompt: |-
      You are about to REMOVE ALL Power Plant Fall Leases.
      Are you sure?
    revenue: Revenue
    revenue_codes: Revenue Code List
    revenue_owners: Revenue Owners
    save: Save
    save_all_years: Save all Years
    save_and_compute: Save and Compute
    save_compute_all: Compute All Years
    select_cols_show: Select Columns to show
    select_columns_to_show: Select Columns to Show
    start_date: Start Date
    threshold_method: Threshold Method
    threshold_rate: Threshold Rate
    threshold_rate_hint: 'For example: 10, 15, 25'
    threshold_type: Threshold Type
    threshold_value: Threshold Value
    threshold_value_hint: 'For example: 0, 16000, 50000'
    total: Total
    total_costs: Total Costs
    total_costs_codes: Total Costs Code List
    total_costs_owners: Costs Owners
    total_fall_leases: Total Fall Lease
    unlock: Unlock
    unlock_all: Unlock All Years
    websocket_connected: Connected to server
    websocket_disconnected: Disconnected from server
    xledger_api:
      insufficient_credits: Insufficient XLedger credits, resets at %{reset_at}
    xledger_id_not_found: XLedger Project ID is not set for this Power Plant
    yearly_production: Yearly Production
